import React from 'react';
import { Home, Building2, Grid3x3, Wrench, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const iconMap = {
  Home: Home,
  Building2: Building2,
  Grid3x3: Grid3x3,
  Wrench: Wrench
};

const ServiceCard = ({ service }) => {
  const IconComponent = iconMap[service.icon];
  
  return (
    <div className="service-card">
      <div style={{marginBottom: '24px'}}>
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: 'var(--brand-primary)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <IconComponent size={30} color="var(--text-inverse)" />
        </div>
        <h3 className="heading-4" style={{color: 'var(--text-primary)', marginBottom: '12px'}}>{service.title}</h3>
        <p className="body-small" style={{color: 'var(--text-secondary)', lineHeight: '1.6'}}>{service.description}</p>
      </div>
      <ul style={{listStyle: 'none', padding: 0, margin: '24px 0'}}>
        {service.features.map((feature, index) => (
          <li key={index} style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
            <div style={{width: '6px', height: '6px', borderRadius: '50%', background: 'var(--brand-primary)'}}></div>
            <span className="body-small" style={{color: 'var(--text-primary)'}}>{feature}</span>
          </li>
        ))}
      </ul>
      <Link to="/services" className="link-text" style={{display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: 'auto'}}>
        Learn More
        <ArrowRight size={16} />
      </Link>
    </div>
  );
};

export default ServiceCard;